import { render, staticRenderFns } from "./BasePwdPaySetup.vue?vue&type=template&id=2cc5881d&scoped=true"
import script from "./BasePwdPaySetup.vue?vue&type=script&lang=js"
export * from "./BasePwdPaySetup.vue?vue&type=script&lang=js"
import style0 from "./BasePwdPaySetup.vue?vue&type=style&index=0&id=2cc5881d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc5881d",
  null
  
)

export default component.exports